export { default } from './text-area';
export type { TextAreaProps } from './types';
